import React from "react";
import HeroTOU from "../Components/Hero/HeroTOU";

const TermsOfUse = () => {
  return (
    <>
      <HeroTOU />
      <section className="st-about-wrap" id="about">
        <div className="container">
          <div className="col-lg">
            <p>
              Welcome to the Dotor Samaj Community app. By using this app, you
              agree to the following terms:
            </p>

            <h4>1. Community-Specific Use:</h4>
            <p>
              This app is exclusively for members of the Dotor Samaj community.
              Registrations are subject to manual verification and approval by
              the Admin. If your registration is not approved, access to the app
              will not be granted.
            </p>

            <h4>2. Eligibility:</h4>
            <p>
              You must be at least 13 years old to use this app. By creating an
              account, you confirm that the information provided is accurate and
              truthful.
            </p>

            <h4>3. User Responsibilities:</h4>
            <p>
              You are responsible for securing your account information,
              including your login credentials. Any activity conducted through
              your account is your responsibility. We are not liable for any
              hacking attempts, data breaches, or loss of data. You are solely
              responsible for safeguarding your data.
            </p>

            <h4>4. Prohibited Activities:</h4>
            <p>
              Users must not:
              <ul>
                <li>Post harmful, illegal, or offensive content.</li>
                <li>Violate the rights of others.</li>
                <li>Attempt to hack, disrupt, or misuse the app.</li>
              </ul>
            </p>

            <h4>5. Termination:</h4>
            <p>
              We reserve the right to suspend or terminate your account if you
              violate these terms. Any attempt to breach these guidelines may
              result in permanent removal from the platform.
            </p>

            <h4>6. Amendments:</h4>
            <p>
              We may update these terms periodically. Continued use of the app
              implies acceptance of any changes. It is your responsibility to
              review the terms regularly to stay informed of any updates.
            </p>

            <p>
              If you have any questions or concerns about these terms, please
              contact us at{" "}
              <a href="mailto:support@dotor.org">support@dotor.org</a>.
            </p>
            <div className="st-height-b125 st-height-lg-b25" />

            <div className="st-height-b0 st-height-lg-b30" />
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsOfUse;
